/* Global imports. */
import React from "react";
import { Link } from "gatsby"

import BannerSimple from "./BannerSimple"
import BannerComplex from "./BannerComplex"
import BannerImage from "./BannerImage"
import BannerBackgroundImage from "./BannerBackgroundImage"

interface Props {
  bannerWidth?: string;
  bannerType?: string;
  title: string;
  text: string;
  buttonText: string;
  buttonUrl: string;
  imageUrl: string;
  imageLinkURL?: string;
  imagePlacement?: string;
  textPlacementClass: string;
  primaryTextColour: string;
  backgroundColour: string;
  backgroundColourLeft: string;
  backgroundColourRight: string;
  isPageHero: boolean;
  componentID?: string;
  referringSlug?: string
  bannerCollectionLength?: number
}

function Banner({ bannerWidth, bannerType, title, text, buttonText, buttonUrl, imageUrl, imageLinkURL, imagePlacement, textPlacementClass, primaryTextColour, backgroundColour, backgroundColourLeft, backgroundColourRight, isPageHero, componentID, referringSlug, bannerCollectionLength}: Props) {
  const bannerTypeInlineImage = "inline_image"
  const bannerTypeBackgroundImage = "background_image"

  let returnedBanner;

  if (bannerType === bannerTypeBackgroundImage && (title === "" && text === "")) {
    returnedBanner = <BannerImage componentID={componentID} imageUrl={imageUrl} imageLinkURL={imageLinkURL} referringSlug={referringSlug} />
  } else if (bannerType === bannerTypeBackgroundImage && (bannerWidth === "flexible")) {
    returnedBanner = <BannerBackgroundImage componentID={componentID} title={title} text={text} buttonText={buttonText} buttonUrl={buttonUrl} imageUrl={imageUrl} backgroundColourLeft={backgroundColourLeft} backgroundColourRight={backgroundColourRight} textPlacementClass={textPlacementClass} referringSlug={referringSlug} />;
  } else if(bannerType === bannerTypeInlineImage && (bannerWidth === "flexible" || bannerWidth === "constrained")) {
    returnedBanner = <BannerComplex componentID={componentID} title={title} text={text} buttonText={buttonText} buttonUrl={buttonUrl} imageUrl={imageUrl} backgroundColourLeft={backgroundColourLeft} backgroundColourRight={backgroundColourRight} imagePlacement={imagePlacement} primaryTextColour={primaryTextColour} referringSlug={referringSlug} />
  } else {
    returnedBanner = <BannerSimple componentID={componentID} title={title} text={text} buttonText={buttonText} buttonUrl={buttonUrl} imageUrl={imageUrl}  textPlacementClass={textPlacementClass} referringSlug={referringSlug} bannerCollectionLength={bannerCollectionLength} primaryTextColour={primaryTextColour} backgroundColour={backgroundColour} />
  }

  return returnedBanner
}

export default Banner;